if(document.querySelector('.call_popup')){
    const callsbtns = document.querySelectorAll('.call_popup')
    callsbtns.forEach(callsbtn => {
        const classpopup = callsbtn.getAttribute('data-popup')      
        const popup = document.querySelector('.' + classpopup)
        // console.log(popup)
        
        const mainpopup = popup.parentElement.parentElement
        const cerrar = popup.querySelector('.cerrar')
        callsbtn.addEventListener('click', ()=>{
            mainpopup.classList.add('active')
            document.querySelector('body').style.overflow = 'hidden'
        })
        cerrar.addEventListener('click', ()=>{
            mainpopup.classList.remove('active')
            document.querySelector('body').style.overflow = 'visible'
        })

        // mainpopup.addEventListener('click', (e)=>{
        //     e.stopPropagation()
        //     console.log(e.target, e.target.classList.contains('.popup_main'))
            
        //     // mainpopup.classList.remove('active')
        //     document.querySelector('body').style.overflow = 'visible'
        // })
        
    });
}